export default [
  {
    title: "Collect Point By Admin",
    customIcon: "CustomSVG",
    children: [
      {
        title: "Collect Point By Admin",
        route: "custom-module",
        path:
          "/custom-module/custom-collect-point-by-admin-approved-receipt-list",
      },
    ],
  },
];
